import Vue from 'vue'
import {VueMaskFilter} from 'v-mask'
import {maskPhone} from '@/helpers/vars'

Vue.filter('VMaskPhone', function (value) {
  return VueMaskFilter(value, maskPhone)
})
